import {IntermediatePart} from "../../intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import Cabinet from "../../parts/cabinet";
import Appliance from "../../parts/appliance";
import store from "../../../../../store";

export default class CrownMolding extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'crown_molding';
    this.partName = 'Crown Molding';
    this.canBeDisabled = true;
    this.layerPriority = 3;
    this.dbName = "crown Molding";
    this.translateId = "visualizer.kitchen.cabinet.crown_molding";
  }

  load(dbFeature) {
    if (!dbFeature.metaData["CabinetLayout"]) {
      dbFeature.metaData["CabinetLayout"] = ["All"]
    }
    if (!dbFeature.metaData["HoodType"]) {
      dbFeature.metaData["HoodType"] = ["All"]// it can be "Wood"
    }
    const parts = dbFeature.metaData && dbFeature.metaData["Parts"];
    if (parts) {
      const partNumber = +dbFeature.metaData["Part"][0];
      return super.load_(dbFeature, new CrownMolding(false, partNumber),
        true, partNumber === 1 ? 'features' : 'featuresParts');
    } else {
      return super.load_(dbFeature, new CrownMolding());
    }
  }

  disabledClick() {
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
    const topCabinet = this.getParent().topCabinet;
    if (topCabinet && topCabinet.disabled && !this.disabled) {
      topCabinet.disabled = this.disabled;
      topCabinet.activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
      const topHandle = this.getParent().topHandle;
      if (topHandle) {
        topHandle.disabled = this.disabled;
      }
    }
  }

  handleClick(ignoreLocked) {
    const parent = this.getParent();
    if (parent.getParent && parent.getParent()) {
      super.handleClick(ignoreLocked);
      parent.activeFeatureParts = parent.setActiveFeatureParts();
    } else {
      parent.crownMolding.activeFeature = this;
    }
    this.featureClicked();
  }

  availableFeatures(cabinetFeatures) {
    return cabinetFeatures.filter(cabinetFeature => cabinetFeature.partNumber === 1)
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    featuresToDisplay = this.getFilteredFeaturesByTopCabinetFilters(featuresToDisplay);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  getFilteredFeaturesByTopCabinetFilters(filteredFeatures) {
    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const topCabinet = cabinetParent.topCabinet;

    if (topCabinet && topCabinet.activeFeature && topCabinet.activeFeature.dbFeature && topCabinet.activeFeature.dbFeature.filterValueIDs) {
      const activeTopCabinetFilters = topCabinet.activeFeature.dbFeature.filterValueIDs;
      const filterGroups = store.getState().filterState.filterGroups;
      const woodTypeFilter = filterGroups.find(group => group.name === "WoodType");
      const stainColorFilter = filterGroups.find(group => group.name === "StainColor");

      return filteredFeatures.filter((currentFeature) => {
        return woodTypeFilter && stainColorFilter && this.featureIsMatchingFilters(currentFeature, activeTopCabinetFilters, [
          woodTypeFilter, stainColorFilter
        ])
      });
    }
    return filteredFeatures
  }

  setLayers(layout) {

    const topCabinet = this.getParent().topCabinet;
    if (topCabinet && (topCabinet.disabled || !topCabinet.featureGroupEnabled)) {
      super.hideLayers();
      return
    }

    if (this.activeFeature && this.matchesByMetaDataAndFilters()
      && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      this.checkIfFeaturePartIsMatching();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  matchesByMetaDataAndFilters() {
    const cabinetParent = this.getParent().layout.parts[Cabinet.id];
    const topCabinet = cabinetParent.topCabinet;

    if (topCabinet && topCabinet.activeFeature && topCabinet.activeFeature.dbFeature && topCabinet.activeFeature.dbFeature.filterValueIDs) {
      const activeTopCabinetFilters = topCabinet.activeFeature.dbFeature.filterValueIDs;
      const filterGroups = store.getState().filterState.filterGroups;
      const woodTypeFilter = filterGroups.find(group => group.name === "WoodType");
      const stainColorFilter = filterGroups.find(group => group.name === "StainColor");
      return woodTypeFilter && stainColorFilter && this.featureIsMatchingFilters(this.activeFeature, activeTopCabinetFilters, [
        woodTypeFilter, stainColorFilter
      ]) && this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
    }
    return this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    const filteredFeaturesByTopCabinetFilters = this.getFilteredFeaturesByTopCabinetFilters(filteredFeatures);
    this.activeFeature = filteredFeaturesByTopCabinetFilters[0] || null;
    this.activeFeatureParts = this.setActiveFeatureParts();
  }

  getArrayOfConditions() {
    const cabinetParent = this.getParent();
    let cabinetLayout = ["All"];
    if (cabinetParent.topCabinet && cabinetParent.topCabinet.activeFeature) {
      if (cabinetParent.topCabinet.activeFeature.metaData["CabinetLayout"]) {
        cabinetLayout = cabinetParent.topCabinet.activeFeature.metaData["CabinetLayout"][0]
      }
    }
    return [{
      propName: 'CabinetLayout',
      propValue: cabinetLayout
    }, {
      propName: "Appliance",
      propValue: cabinetParent.getTopCabinetApplianceType()
    }, {
      propName: 'RoomLayout',
      propValue: cabinetParent.layout.getCurrentLayoutAbbreviation()
    }];
  }

  getActiveFeatureConditions() {
    let hoodType = ["All"];
    const cabinetParent = this.getParent();
    const isHood = cabinetParent.getTopCabinetApplianceType() === "Hood";
    const isMicrowave = cabinetParent.getTopCabinetApplianceType() === "Microwave";
    const applianceParent = cabinetParent.layout.parts[Appliance.id];
    if (isHood && applianceParent.hood && applianceParent.hood.activeFeature
      && applianceParent.hood.activeFeature.metaData && applianceParent.hood.activeFeature.metaData["HoodType"]) {
      hoodType = applianceParent.hood.activeFeature.metaData["HoodType"][0];
    }
    const conditions = this.getArrayOfConditions();
    conditions.push({
      propName: "HoodType",
      propValue: isMicrowave ? "Wood" : hoodType
    });
    return conditions
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    return this.getActiveFeaturePartsAccordingToActiveFeature(fromFeature, activeFeatureConditions);
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Cabinet.CrownMolding;
      const zIndex2 = zIndexes.Cabinet.CrownMolding2;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
      if (this.activeFeatureParts && this.activeFeatureParts.length) {
        this.activeFeatureParts.forEach((activeFeaturePart) => {
          if(activeFeaturePart && activeFeaturePart.layer) activeFeaturePart.layer.zIndex = zIndex2;
        })
      }
    }
  }

}
